<script>
  import Chart from "chart.js/auto";
  import { onMount } from "svelte";
  import distinctColors from "distinct-colors";

  export let id = "1000";
  export let type = "line";
  export let line_data;
  export let display_legend = true;
  export let barPercentage = 0.9;
  export let categoryPercentage = 0.8;
  export let show_tooltip = true;
  export let salesman_selected;
  export let redraw = false;

  let data = {
    labels: ["A"],
    datasets: [
      {
        data: [12],
        backgroundColor: palette_array,
        hoverBackgroundColor: palette_array,
      },
    ],
  };

  // CommonJS
  // var distinctColors_obj = require('distinct-colors').default
  var palette = distinctColors({ count: 100 }); // You may pass an optional config object
  var palette_array = [];

  let index = 1;
  palette.forEach((element) => {
    if (index > 3) {
      palette_array.push(element.toString());
    }
    index = index + 1;
  });

  const DATA_COUNT = 7;

  let labels = ["A", "B", "C", "D", "E", "F", "G"];

  const config = {
    data: data,
    options: {
      responsive: true,
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
          beginAtZero: true,
        },
      },
      plugins: {
        datalabels: {
          color: "#FFFFFF",
        },
        title: {
          display: true,
          text: "",
        },
        tooltip: {
          mode: "index",
          enabled: show_tooltip,
        },
        legend: {
          display: display_legend,
        },
      },
    },
  };

  let ctx;
  let myChart;

  let last_selected = "";
  let first_create = true;

  $: {
    salesman_selected, redraw;
    if (salesman_selected != last_selected || redraw) {
      if (salesman_selected.length > 0 && line_data) {
        last_selected = salesman_selected;
        // console.log('salesman_selected: ', salesman_selected);
        // console.log('line_data: ', line_data);
        // console.log('id: ', id);
        if (type == "bar") {
          //change backgroundcolor entries:

          let datasets = [];
          let i = 0;

          line_data["datasets"].forEach(function (element) {
            let t = element;
            t["backgroundColor"] = palette_array[i];
            t["categoryPercentage"] = categoryPercentage;
            t["barPercentage"] = barPercentage;
            i = i + 1;
            datasets.push(t);
          });

          if (myChart) {
            // console.log('DESTROY');
            myChart.destroy();
            myChart = new Chart(ctx, {
              type: type,
              options: config["options"],
              data: {
                labels: line_data["labels"],
                datasets: datasets,
              },
              onClick: function () {},
            });
          }
        } else {
          // console.log('id: ', id);
          // console.log('DATEN: ');
          // console.log('labels: ', line_data['labels']);
          // console.log('datasets: ', line_data['datasets']);

          if (myChart) {
            // console.log('DESTROY');
            myChart.destroy();
            myChart = new Chart(ctx, {
              type: "line",
              options: config["options"],
              data: {
                labels: line_data["labels"],
                datasets: line_data["datasets"],
              },
              onClick: function () {},
            });
          }
        }
      }
    }
  }

  $: {
    let data_changed = line_data;

    if (data_changed) {
      // console.log('data_changed in line chart: ', data_changed);

      if (first_create) {
        onMount(() => {
          ctx = document.getElementById("myChart" + id.toString()).getContext("2d");

          if (type == "bar") {
            //change backgroundcolor entries:

            let datasets = [];
            let i = 0;

            line_data["datasets"].forEach(function (element) {
              let t = element;
              t["backgroundColor"] = palette_array[i];
              t["categoryPercentage"] = categoryPercentage;
              t["barPercentage"] = barPercentage;
              i = i + 1;
              datasets.push(t);
            });

            myChart = new Chart(ctx, {
              type: type,
              options: config["options"],
              data: {
                labels: line_data["labels"],
                datasets: datasets,
              },
              onClick: function () {},
            });
          } else {
            myChart = new Chart(ctx, {
              type: "line",
              options: config["options"],
              data: {
                labels: line_data["labels"],
                datasets: line_data["datasets"],
              },
              onClick: function () {},
            });
          }
          first_create = false;
        });
      }
    }
  }
</script>

<canvas id="myChart{id}" />
